// extracted by mini-css-extract-plugin
module.exports = {"RiskTile__Header":"styles_RiskTile__Header__11uF8","RiskTile__Actions":"styles_RiskTile__Actions__25atj"};